import axios from 'axios';
import {isArrayFun} from '../utils/utils';
import {getStore} from '../utils/utils';
// import qs from 'qs';

axios.defaults.timeout = 60000; // 响应时间
const basrURL = 'https://adr.ccpit.org/interface';

axios.defaults.baseURL = basrURL; // 配置接口地址

// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) =>
  // 在发送请求之前做某件事
  config,
(error) => {
  console.log('错误的传参');
  return Promise.reject(error);
});

// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  // 对响应数据做些事
  if (!res.data.success) {
    return Promise.resolve(res);
  }
  return res;
}, (error) => {
  console.log('网络异常');
  return Promise.reject(error);
});

const upServer = function (opts, data) {
  const httpDefaultOpts = {
    // http默认配置
    method: opts.method || 'post',
    url: opts.url,
    headers: {
      'Content-Type': 'multipart/form-data',
      //appName: 'mediate',
      cType: 'h5',
      token: getStore('token'),
    },
  };
  const forms = new FormData();
  if(isArrayFun(data.file)){
    for(var i=0; i<data.file.length; i++){
      forms.append('file['+i+']', data.file[i]);
    }
  } else {
    forms.append('file', data.file);
  }
  Object.keys(data.param).forEach((key) => {
    forms.append(key, data.param[key]);
  });
  httpDefaultOpts.data = forms;
  console.log(httpDefaultOpts.data)
  const promise = new Promise(((resolve, reject) => {
    axios(httpDefaultOpts)
      .then((res) => {
        resolve(res);
      })
      .catch((response) => {
      /* errorState(response) */
        reject(response);
      });
  }));
  return promise;
};

export default upServer;
